import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SupplierGroupsDataGrid } from "src/components/views/erp/purchase/supplierGroups/SupplierGroupsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/purchase/supplierGroups")({
	staticData: { title: i18n.t("supplier_groups"), legacyViewKey: "supplierGroupsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SupplierGroupsDataGrid />;
}
